<template>
    <div>
        <div id="pvuvChart" style="width: 100%;padding-top:10px;"></div>
    </div>
</template>

<script>

export default {
    data(){
        return {
            dateList:[],
            seriesList:[],
            chartSys:null,
        }
    },
    methods:{

        loadData(res){
            let trackDataX = [];
            let trackDataY = [];

            let that = this;
            that.dateList = [];
            that.seriesList = [];

            for (let index = 0; index < res.length; index++) {
                const element = res[index];
                const target = element.split(',');
                trackDataX.push(target[0])
                trackDataY.push(target[1])
                that.dateList.push(target[2])
            }

            that.seriesList.push({
                name:'x',
                type: 'line',
                smooth: true,
                stack: '总量1',
                itemStyle: {
                    normal: {
                        color: '#ffdd55',
                        borderColor: '#ffdd55',
                        areaStyle: {
                            type: 'default',
                            opacity: 0.1
                        }
                    }
                },
                data: trackDataX,
            })
            that.seriesList.push({
                name:'y',
                type: 'line',
                smooth: true,
                stack: '总量2',
                itemStyle: {
                    normal: {
                        color: '#57d4e2',
                        borderColor: '#57d4e2',
                        areaStyle: {
                            type: 'default',
                            opacity: 0.1
                        }
                    }
                },
                data: trackDataY
            })
            that.analystData();
            
        },

        analystData(){
            
            let that = this;
            if(that.chartSys){
                that.chartSys.clear();
            }
            document.getElementById("pvuvChart").style.height = "800px";
            that.chartSys = that.$echarts.init(document.getElementById("pvuvChart"));
            
            let option = that.getDatailOption();
            // 窗口大小自适应方案
            that.chartSys.setOption(option);
            that.chartSys.off('click');
            that.chartSys.on('click', function () {
               
            });
            
        },
        getDatailOption(){
            let that = this;
           
            // 基于准备好的dom，初始化echarts实例
            // 绘制图表配置
            let option = {
                title: {
                    show: false
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                color:['#ffdd55','#57d4e2'],

                legend: {
                    data: ['x','y'],
                    left: 'center',
                    top:'top',
                    show:false,
                },
                grid: {
                    top:'25px',
                    bottom:'30px'
                },
                xAxis: [
                    {
                        type: 'category',
                        data: that.dateList.map(function (str) {
                            return str
                        })
                    }
                ],
                yAxis: [
                    {
                        type: 'value'
                    }
                ],
                series: that.seriesList
            };
            return option
        },
        chartResize(){
            let eleArr = [this.chartSys];
            for(let i = 0; i<eleArr.length; i++){
                //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
                setTimeout(function(){
                    if(eleArr[i]){
                        eleArr[i].resize();
                    }
                }, 200);
            }
        },
    },
    mounted(){
        window.addEventListener("resize", this.chartResize);
    },
    destroyed(){
        window.removeEventListener("resize", this.chartResize);

    },

    props:{
    },
    components:{
    },
};
</script>

<style lang="less" scoped>
.main_box{
    width: 500px;
    height: auto;
    float: left;
    margin-left: 20px;
}


</style>
